/* INTEGY V610 — correctness pass after V609.
   1) keeps the early stock state synchronized with URL changes,
   2) corrects one-page Mini XRT/Mini Slash visible counts,
   3) normalizes two proven mega-menu scale/model labels.
   Dynamic indexed grids remain owned by V577/V568. */
(function () {
  'use strict';
  var root = document.documentElement;

  function stockMode() {
    try {
      var q = new URLSearchParams(location.search || '');
      if (q.get('filter.v.availability') === '0' || q.get('integy_stock') === 'out') return 'out';
      if (q.get('integy_stock') === 'all') return 'all';
      return 'in';
    } catch (e) { return 'in'; }
  }

  function syncStockClass() {
    var mode = stockMode();
    root.classList.remove('integy-v610-stock-request-in','integy-v610-stock-request-out','integy-v610-stock-request-all');
    root.classList.add('integy-v610-stock-request-' + mode);
  }

  function collectionHandle() {
    var m = String(location.pathname || '').match(/^\/collections\/([^/?#]+)/i);
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  }

  function visibleStockCount(grid) {
    var mode = stockMode();
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product-item][data-product-available]'));
    if (mode === 'all') return cards.length;
    return cards.filter(function (card) {
      var available = card.getAttribute('data-product-available') === 'true';
      return mode === 'out' ? !available : available;
    }).length;
  }

  function repairSmallCompatibilityCount() {
    var handle = collectionHandle();
    if (handle !== 'hop-up-parts-for-traxxas-mini-xrt' && handle !== 'hop-up-parts-for-traxxas-mini-slash-4x4') return;
    var grid = document.querySelector('[data-productgrid-items].productgrid--items:not(.integy-v307-canonical-grid)');
    if (!grid) return;
    var count = visibleStockCount(grid);
    var chip = document.querySelector('[data-integy-collection-product-count]');
    if (chip && chip.textContent !== count + ' products') chip.textContent = count + ' products';
    var notice = document.querySelector('[data-integy-v453-server-fallback] strong, .integy-v453-compatibility-notice strong');
    if (notice) {
      var next = count + ' compatible product' + (count === 1 ? '' : 's') + ' found';
      if (notice.textContent !== next) notice.textContent = next;
    }
  }

  function normalizeMenuLabels() {
    var anchors = document.querySelectorAll('header a, .site-header a, .site-navigation a, .navmenu a, [data-site-navigation] a, [data-mobile-nav] a');
    Array.prototype.forEach.call(anchors, function (a) {
      if (!a || a.children.length) return;
      var text = String(a.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === '1/8 E-Savage MT') {
        a.textContent = '1/10 E-Savage MT';
        a.setAttribute('data-integy-v610-menu-normalized','e-savage');
      } else if (text === '1/10 Slash 4X4 (-2023)') {
        a.textContent = '1/10 Slash 4X4 Non-LCG (-2023)';
        a.setAttribute('data-integy-v610-menu-normalized','slash-non-lcg');
      }
    });
  }

  function run() {
    syncStockClass();
    repairSmallCompatibilityCount();
    normalizeMenuLabels();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  /* V568/V577 can rebuild a filtered grid. Re-run only cheap idempotent repairs;
     do not observe stock-status text, which V609 deliberately isolated. */
  if (window.MutationObserver && document.body) {
    var timer = 0;
    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        var t = m.target && m.target.nodeType === 1 ? m.target : m.target && m.target.parentElement;
        if (!t) return false;
        if (t.closest && t.closest('[data-integy-v449-stock-status]')) return false;
        return !!(t.closest && (t.closest('[data-productgrid-items]') || t.closest('header') || t.closest('[data-mobile-nav]')));
      });
      if (!relevant) return;
      clearTimeout(timer);
      timer = setTimeout(run, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.IntegyV610Correctness = { version: 'V610', run: run, stockMode: stockMode };
}());
